"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var kiwi = require("kiwi.js");
exports.Operator = kiwi.Operator;
exports.Strength = kiwi.Strength;
/* FUNCTIONS */
exports.Expression = {
    toString: function (expression) {
        var bits = [];
        var first = true;
        function numberBits(n, isCoefficient) {
            if (isCoefficient && first) {
                if (n === 1) {
                    return [];
                }
                else if (n === -1) {
                    return ['-'];
                }
                else {
                    return [n.toString(), ' '];
                }
            }
            else if (isCoefficient && !first) {
                var abs = Math.abs(n);
                return [n > 0 ? ' + ' : ' - ', abs === 1 ? '' : (abs.toString() + ' ')];
            }
            else if (!isCoefficient && first) {
                return [n.toString()];
            }
            else { // !isCoefficient && !first
                var abs = Math.abs(n);
                return [n > 0 ? ' + ' : ' - ', abs.toString()];
            }
        }
        _.forEach(expression.terms, function (coeff, variableName) {
            if (variableName.indexOf(' ') !== -1) {
                variableName = '[' + variableName + ']';
            }
            bits.push.apply(bits, numberBits(coeff, true).concat([variableName]));
            first = false;
        });
        if (expression.constant !== 0 || first) {
            bits.push.apply(bits, numberBits(expression.constant, false));
        }
        return bits.join('');
    },
    constant: function (number) {
        return { terms: {}, constant: number };
    },
    asConstant: function (expr) {
        if (_.size(expr.terms) === 0) {
            return expr.constant;
        }
        else {
            return undefined;
        }
    },
    variable: function (variableName) {
        var _a;
        return { terms: (_a = {}, _a[variableName] = 1, _a), constant: 0 };
    },
    from: function (thing) {
        if (typeof thing == 'string') {
            return exports.Expression.variable(thing);
        }
        else if (typeof thing == 'number') {
            return exports.Expression.constant(thing);
        }
        else {
            return thing;
        }
    },
    plus: function (left, right) {
        var terms = {};
        _addToMutableTerms(terms, left.terms);
        _addToMutableTerms(terms, right.terms);
        return { terms: terms, constant: left.constant + right.constant };
    },
    minus: function (left, right) {
        return exports.Expression.plus(left, exports.Expression.timesNum(right, -1));
    },
    times: function (left, right) {
        var rightConstant = exports.Expression.asConstant(right);
        if (rightConstant !== undefined) {
            return exports.Expression.timesNum(left, rightConstant);
        }
        var leftConstant = exports.Expression.asConstant(left);
        if (leftConstant !== undefined) {
            return exports.Expression.timesNum(right, left.constant);
        }
        throw new Error("To multiply, you need a constant on the left or the right.");
    },
    timesNum: function (expr, num) {
        return {
            terms: _.mapValues(expr.terms, function (coeff) { return coeff * num; }),
            constant: expr.constant * num,
        };
    },
    divide: function (left, right) {
        var rightConstant = exports.Expression.asConstant(right);
        if (rightConstant !== undefined) {
            return exports.Expression.timesNum(left, 1 / rightConstant);
        }
        throw new Error("To divide, you need a constant on the right.");
    },
};
function _addToMutableTerms(mutableTerms, newTerms) {
    _.forEach(newTerms, function (coeff, variableName) {
        mutableTerms[variableName] = (mutableTerms[variableName] || 0) + coeff;
    });
}
exports.Constraint = {
    toString: function (constraint) {
        return exports.Expression.toString(constraint.expression) + " " + ["<=", ">=", "="][constraint.operator] + " 0 {" + constraint.strength + "}";
    },
    equals: function (left, right, strength) {
        if (strength === void 0) { strength = exports.Strength.medium; }
        return { expression: exports.Expression.minus(left, right), operator: exports.Operator.Eq, strength: strength };
    },
    greater: function (left, right, strength) {
        if (strength === void 0) { strength = exports.Strength.medium; }
        return { expression: exports.Expression.minus(left, right), operator: exports.Operator.Ge, strength: strength };
    },
    less: function (left, right, strength) {
        if (strength === void 0) { strength = exports.Strength.medium; }
        return { expression: exports.Expression.minus(left, right), operator: exports.Operator.Le, strength: strength };
    },
    weak: function (constraint) {
        return __assign({}, constraint, { strength: kiwi.Strength.weak });
    },
    strong: function (constraint) {
        return __assign({}, constraint, { strength: kiwi.Strength.strong });
    },
    required: function (constraint) {
        return __assign({}, constraint, { strength: kiwi.Strength.required });
    },
};
function setVars(vars, vals, strength) {
    if (strength === void 0) { strength = exports.Strength.strong; }
    return _.map(vals, function (val, key) {
        return exports.Constraint.equals(exports.Expression.variable(vars[key]), exports.Expression.from(val), strength);
    });
}
exports.setVars = setVars;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../kiwifruit/kiwifruit-core/build/index.js
// module id = 49
// module chunks = 0